import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';

import { company } from '~/company/Company';
import { CommonCarousel } from '~/components/CommonCarousel';
import ProductCard from '~/components/ProductCard/ProductCard';
import ProductCardSkeleton from '~/components/ProductCard/ProductCardSkeleton';
import { useGlobal } from '~/hooks/useGlobal';
import { Category } from '~/stores/CategoriesStore';

import CategoryBlockTitle from '../CategoryBlockTitle';
import { createCategoryUrl } from '../utils';

import { carouselProps } from './config';
import styles from './ProductsCarouselSliderOneBlock.module.scss';
import './styles.scss';

interface ProductsCarouselSliderOneBlockProps {
  category: Category;
}

const ProductsCarouselSliderOneBlock = ({
  category,
}: ProductsCarouselSliderOneBlockProps) => {
  const { pathname } = useLocation();
  const { isMobile } = useGlobal();

  if (
    !(category.products?.length ?? 0) &&
    category.productsRequest.isFulfilled
  ) {
    return null;
  }

  const currentProps = carouselProps[company.name];
  const categoryId = category?.subcategory[0]?.id;

  if (!category.subcategory.length || !categoryId) {
    return null;
  }

  return (
    <div
      data-company={company.name}
      className={classes([
        styles.container,
        'product-carousel-slider-one-block',
      ])}
    >
      <CategoryBlockTitle
        hasLink={pathname !== '/search'}
        text={category.name}
        description={category.previewText}
        backgroundColor={category.backgroundColor}
        categoryId={categoryId}
        linkTo={createCategoryUrl({ id: categoryId })}
      />
      <CommonCarousel
        {...currentProps}
        slidesPerViewProp={isMobile ? 2 : 5}
        skeletonComponent={
          <ProductCardSkeleton className={styles.productSkeleton} />
        }
      >
        {(category.products ?? [])
          .slice(0, isMobile ? 10 : 15)
          .map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              variant={company.productCardVariantL}
            />
          ))}
      </CommonCarousel>
    </div>
  );
};

export default observer(ProductsCarouselSliderOneBlock);
